import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getThemeComponent } from '@/utils/themeImports';
import { setCart } from 'src/redux/actions';
import VariantModal from '../../components/VariantModal';
import VariantChooseRepeatModal from '../../components/VariantChooseRepeatModal';
import VariantSelectedListModal from '../../components/VariantSelectedListModal';
import { getStoreType } from '@/utils/getStoreType';
import { specificThemeRender } from '@/utils/specificThemeRender';
import QuickViewModal from '@/components/DesignSystem/QuickViewModal';
import { ORDER_TYPE, STORE_CUSTOMIZATION } from '@/utils/constants';
import { useSSRSelector } from '@/redux/ssrStore';
import InstallAppInstructionsOverlay from '../../components/InstallAppInstructionsOverlay';
import { ProductCustomizationPopUp } from '@/components/ProductCustomizationPopUp';
import { FullPageLoader } from '../../components/FullPageLoader/FullPageLoader';
import { IS_SERVER } from '../../utils/checkRenderEnv';
import PromosDrawerAndButton from 'src/components/CouponsAndVouchers/PromosDrawerAndButton';
// import useSetCart from '@/utils/customHooks';

const Shop = () => {
  const dispatch = useDispatch();
  // const { triggerSetCart } = useSetCart();
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const { cart, personalizedProduct } = useSelector((state) => ({
    cart: state.cartReducer,
    personalizedProduct: state.catalogReducer?.personalizedProduct,
  }));
  const isB2bStore = getStoreType(storeData) === STORE_CUSTOMIZATION.B2B;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');

    if (!IS_SERVER && localStorage?.getItem('utm_source') !== utmSource) {
      localStorage?.setItem('utm_source', utmSource);
    }
  }, []);

  useEffect(() => {
    if (cart.items && cart.items.length > 0) {
      setCartAsyncCall();
    }
  }, [cart.pay_amount]);

  const setCartAsyncCall = () => {
    return new Promise((resolve, reject) => {
      dispatch(
        setCart(
          {
            ...cart,
            order_type: isB2bStore ? ORDER_TYPE.B2B : cart.order_type,
            order_mode: isB2bStore ? 3 : cart.order_mode,
            store_id: storeData?.store_id,
            user_phone: cart.phone,
            cart_id: cart.cart_id,
          },
          (status) => {
            resolve();
          }
        )
      );
    });
  };

  return (
    <section className="relative">
      <FullPageLoader />
      {specificThemeRender(storeData)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, layout);
      })}
      {specificThemeRender(storeData)?.components?.PLP?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, {
          showATCBtn: true,
          shopPageBoolean: true,
          ...layout,
        });
      })}
      {specificThemeRender(storeData)?.components?.Footer?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, layout);
      })}
      <VariantModal />
      <VariantChooseRepeatModal />
      <VariantSelectedListModal />
      <QuickViewModal />
      <InstallAppInstructionsOverlay />
      {personalizedProduct?.personalizationPopUp && <ProductCustomizationPopUp />}
      <PromosDrawerAndButton />
    </section>
  );
};

export default Shop;
